import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { Toast } from '@ionic-native/toast';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { File } from '@ionic-native/file';
import { FileOpener } from '@ionic-native/file-opener';
import { FileTransfer } from '@ionic-native/file-transfer';
import { DocumentViewer } from '@ionic-native/document-viewer';

import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule } from '@angular/common/http';
import { PipesModule } from '../pipes/pipes.module';

import { SpinnerProvider } from '../providers/spinner/spinner';
import { AlertProvider } from '../providers/alert/alert';
import { NetworkProvider } from '../providers/network/network';
import { HttpProvider } from '../providers/http/http';
import { CardapioOnlineProvider } from '../providers/cardapio-online/cardapio-online';
import { ConfiguracaoConcessionariaProvider } from '../providers/configuracao-concessionaria/configuracao-concessionaria';
import { registerLocaleData } from '@angular/common';

import ptBr from '@angular/common/locales/pt';
import { OrdemServicoProvider } from '../providers/ordem-servico/ordem-servico';
import { ChecklistProvider } from '../providers/checklist/checklist';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Insomnia } from '@ionic-native/insomnia';
import { OrcamentoProvider } from '../providers/orcamento/orcamento';
import { PesquisaProvider } from '../providers/pesquisa/pesquisa';
import { GestaoPatioProvider } from '../providers/gestao-patio/gestao-patio';

import { SocketProvider } from '../providers/socket/socket';
import { PdfProvider } from '../providers/pdf/pdf';

import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
import { PerguntaCompletaComponent } from '../components/pergunta-completa/pergunta-completa';
import { IonicSelectableModule } from 'ionic-selectable';

//import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';

// import { BackgroundMode } from '@awesome-cordova-plugins/background-mode/ngx';
// import { PushNotificationProvider } from '../providers/push-notification/push-notification';

const config: SocketIoConfig = { url: 'https://node-indicar.azurewebsites.net', options: {} };

registerLocaleData(ptBr);

@NgModule({
  declarations: [
    MyApp,
    PerguntaCompletaComponent
  ],
  imports: [
    BrowserModule,
    SocketIoModule.forRoot(config) ,
    IonicModule.forRoot(MyApp,
      {
        backButtonText: 'Voltar',
        preloadModules: true,
        platforms: {
          ios: {
            statusbarPadding: true,
            scrollAssist: true,
            autoFocusAssist: true,
            scrollPadding: true
          }
        }
      }),
    //IonicModule.forRoot(MyApp, {backButtonText: 'Voltar'}),
    HttpClientModule,
    IonicStorageModule.forRoot(),
    PipesModule,
    IonicSelectableModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    PerguntaCompletaComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    CardapioOnlineProvider,
    ConfiguracaoConcessionariaProvider,
    OrdemServicoProvider,
    OrdemServicoProvider,
    ChecklistProvider,
    OrcamentoProvider,
    Toast,
    PesquisaProvider,
    GestaoPatioProvider,
    SpinnerProvider,
    AlertProvider,
    NetworkProvider,
    HttpProvider,
    ScreenOrientation,
    File,
    FileOpener,
    FileTransfer,
    DocumentViewer,
    AndroidPermissions,
    Insomnia,
    SocketProvider,
    PdfProvider,
  //  PushNotificationProvider,
  //  OneSignal
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts